var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { Button, TextField } from "@savvyinsure/react-ui";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import { completedPage } from "../../../lib/Avo";
import { saveHomeowners } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { validatePropertySquareFootage } from "../../../features/unlinked-application/utils";
var nextRoute = PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PREMIUM;
export default function UnlinkedApplicationHomeownersSquareFootage() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var homeowners = useAppSelector(function (state) { return state.unlinkedApplication; }).homeowners;
    var history = useHistory();
    var dispatch = useAppDispatch();
    var _a = useForm({
        mode: "all",
        defaultValues: {
            squareFootage: homeowners.squareFootage,
        },
    }), register = _a.register, handleSubmit = _a.handleSubmit, _b = _a.formState, errors = _b.errors, isValid = _b.isValid, watch = _a.watch;
    var squareFootageValue = watch("squareFootage");
    var onSubmit = handleSubmit(function (data) {
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Continue", optionSelected: "Continue" }));
        dispatch(saveHomeowners(data));
        history.push(nextRoute);
    });
    function handleOnCloseHeader() {
        var squareFootageIdValid = validatePropertySquareFootage(squareFootageValue);
        if (!squareFootageIdValid)
            return;
        dispatch(saveHomeowners({ squareFootage: squareFootageValue }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { onClose: handleOnCloseHeader, showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { onSubmit: onSubmit, className: "px-6 pt-4", as: "form" },
            React.createElement(UnlinkedApplicationForm.Header, { className: "mb-6" }, "What is the estimated square footage of your home?"),
            React.createElement(TextField, __assign({ label: "Square Footage", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.squareFootage), type: "number", wrapperClassName: "mb-4" }, register("squareFootage", {
                required: true,
                valueAsNumber: true,
            }))),
            React.createElement(Button, { disabled: !isValid }, "Continue"))));
}
